import { render, staticRenderFns } from "./AImage.vue?vue&type=template&id=634e8c7b"
import script from "./AImage.vue?vue&type=script&lang=js"
export * from "./AImage.vue?vue&type=script&lang=js"
import style0 from "./AImage.vue?vue&type=style&index=0&id=634e8c7b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports